var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MyHead',{on:{"add":_vm.addTask}}),_vm._v(" "),_c('MyContent',{attrs:{"todos":_vm.todos,"delTask":_vm.delTask}}),_vm._v(" "),_c('MyFoot',{attrs:{"todos":_vm.todos,"selectAll":_vm.selectAll,"delAllTack":_vm.delAllTack}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-089b2c1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 